import { Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { ClienteForm } from "./ClienteForm";
import { clienteStartAdd, clienteStartUpdate } from "../../../actions";
import { FormUi } from "../../ui";
import dayjs from "dayjs";

const initialValues = (data = {}) => ({
  id: data?.id || dayjs().valueOf(),
  tipodocumento: data?.persona?.tipodocumento || null,
  nrodocumento: data?.persona?.nrodocumento || null,
  nombrecompleto: data?.persona?.nombrecompleto || null,
  nombres: data?.persona?.nombres || null,
  apepaterno: data?.persona?.apepaterno || null,
  apematerno: data?.persona?.apematerno || null,
  fechanacimiento: data?.persona?.fechanacimiento || null,
  departamento: data?.persona?.departamento || null,
  provincia: data?.persona?.provincia || null,
  ubigeodireccion: data?.persona?.ubigeodireccion || null,
  direccion: data?.persona?.direccion || null,
  telefono: data?.persona?.telefono || null,
  email: data?.persona?.email || null,
  website: data?.persona?.website || null,
  state: data ? data?.state : true,
});

export const ClienteScreen = ({ handleCloseForm }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { activeCliente } = useSelector((state) => state.cliente);

  const handleSave = (values) => {
    console.log(values);
    if (activeCliente) {
      dispatch(clienteStartUpdate(values));
    } else {
      dispatch(clienteStartAdd(values));
    }
    handleCloseForm();
  };

  return (
    <FormUi
      form={form}
      name="FormClientes"
      layout="vertical"
      autoComplete="off"
      handleSubmit={handleSave}
      initialValues={initialValues(activeCliente)}
    >
      <ClienteForm handleCloseForm={handleCloseForm} />
    </FormUi>
  );
};
